import { render, staticRenderFns } from "./AdminActionMenu.vue?vue&type=template&id=bf9438d6&scoped=true"
import script from "./AdminActionMenu.vue?vue&type=script&lang=js"
export * from "./AdminActionMenu.vue?vue&type=script&lang=js"
import style0 from "./AdminActionMenu.vue?vue&type=style&index=0&id=bf9438d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9438d6",
  null
  
)

export default component.exports